import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { IForm } from "@/types";
import { CSSProperties } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
    field: IForm["fields"][0];
    admin?: boolean;
    setSelectedField?: (field: IForm["fields"][0]) => void; // Allow setting selected field
    value?: string; // Optional value prop
    className?: string;
    style?: CSSProperties;
}

export const TextOnlyField = ({
    field,
    admin,
    setSelectedField,
    value,
    className,
    style,
}: Props) => {
    const formContext = useFormContext();
    const register = admin ? () => {} : formContext.register;
    const errors = admin ? {} : formContext.formState.errors;

    return (
        <div
            className={cn("flex w-full flex-col gap-1", className)}
            onClick={() => {
                if (admin && setSelectedField) {
                    setSelectedField(field); // Open item when admin clicks
                }
            }}
        >
            <Label variant="toggle" className="!text-form-primary-text-color">
                {field.question || (
                    <span className="text-form-primary-text-color/70">
                        Write text here...
                    </span>
                )}

            </Label>
        </div>
    );
};
